import {
  boolean,
  doublePrecision,
  index,
  integer,
  pgTable,
  primaryKey,
  text,
  uniqueIndex,
} from 'drizzle-orm/pg-core'

import { createdAt, primaryId, updatedAt } from './columns.ts'
import { offering } from './offerings.ts'

/**
 * Where the work can happen. Cities are shared across the whole offer rather
 * than owned by one page: adding Kraków is one row, and letting a photographer
 * travel there is one checkbox, not a new entity.
 */
export const city = pgTable(
  'city',
  {
    id: primaryId('city'),
    slug: text('slug').notNull(),
    name: text('name').notNull(),
    /** Where the team is based vs. where it travels — drives the map legend. */
    note: text('note'),
    /** WGS84, feeds the map projection. Coordinates, not money — float is fine. */
    longitude: doublePrecision('longitude').notNull(),
    latitude: doublePrecision('latitude').notNull(),
    sortOrder: integer('sort_order').notNull().default(0),
    isActive: boolean('is_active').notNull().default(true),

    createdAt: createdAt(),
    updatedAt: updatedAt(),
  },
  (t) => [uniqueIndex('city_slug_unique').on(t.slug)],
)

/**
 * Which cities a `CITIES`-mode offering covers. Rows are only read when the
 * offering says `CITIES`, so a list left behind by a switch to `ONLINE` cannot
 * silently narrow it back.
 */
export const offeringCity = pgTable(
  'offering_city',
  {
    offeringId: text('offering_id')
      .notNull()
      .references(() => offering.id, { onDelete: 'cascade' }),
    cityId: text('city_id')
      .notNull()
      .references(() => city.id, { onDelete: 'cascade' }),

    createdAt: createdAt(),
  },
  (t) => [
    primaryKey({ columns: [t.offeringId, t.cityId] }),
    index('offering_city_city_idx').on(t.cityId),
  ],
)

export type City = typeof city.$inferSelect
export type NewCity = typeof city.$inferInsert
